import {
  Accordion,
  AccordionDetails,
  AccordionSummary,
  Card,
  CardContent,
  Checkbox,
  FormControlLabel,
  Grid
} from '@material-ui/core'
import AsterButton from 'asterX-UI/Buttons/AsterButton'
import { ArrowLeftIcon } from 'asterX-UI/Icons'
import { useRoutes } from 'hooks'
import { HOME_PATH } from 'routes/constants.routes'
import { useWorkListViewRopStore } from 'context/WorkListViewStore/Rop/WorkListViewStore.rop'
import AsterTypography from 'asterX-UI/Typography/AsterTypography'
import { useStyles } from './work-list-view.styles'
import { AsterProgress } from 'asterX-UI/Progress/AsterProgress'
import React, { useState } from 'react'
import AsterChip from 'asterX-UI/DataDisplay/AsterChip'
import { colorStatusesByCode } from 'constants/deals'
import FieldInfoNG from 'asterX-UI/DataDisplay/FieldInfoNG'
import TimerDiffDate from 'components/TimerDiffDate'
import clsx from 'clsx'
import PhoneView from 'components/PhoneView'
import { ERROR_COLORS } from 'asterX-UI'
import CarImg from 'assets/img/car_placeholder.jpg'
import CardMedia from '@material-ui/core/CardMedia'
import CreditApprovalModal from 'components/Mobile/CreditApprovalModal'
import { WorkListTabs } from '../WorkListTabs/WorkListTabs'
import { NotFound } from 'components/NotFound'
import { ArrowForwardIosRounded } from '@material-ui/icons'
import { Modal } from 'asterX-UI/Modals'
import CarData from 'components/Mobile/Car/CarData'

export const WorkListView = () => {
  const classes = useStyles()
  const router = useRoutes()

  const {
    store: { wlData },
    actions: { handleRopCheck }
  } = useWorkListViewRopStore()

  const [expanded, setExpanded] = useState(false)
  const [activeCar, setActiveCar] = useState(null)
  const progressPercent =
    !!wlData?.contractStatusTrack?.current &&
    !!wlData?.contractStatusTrack?.total
      ? (wlData?.contractStatusTrack?.current /
          wlData?.contractStatusTrack?.total) *
        100
      : 0
  const handleCarClick = car => {
    setActiveCar(car)
  }

  return (
    <Grid container className={classes.wlViewWrapper}>
      <Grid item xs={12} style={{ marginBottom: 24 }}>
        <AsterButton size="small" onClick={() => router.goTo(HOME_PATH)}>
          <ArrowLeftIcon />
          Назад
        </AsterButton>
      </Grid>
      <Grid item container alignItems="center">
        <Grid item xs={12} style={{ marginBottom: 12 }}>
          <AsterTypography variant="h6">РЛ: {wlData?.id || ''}</AsterTypography>
        </Grid>

        <Grid item xs={12}>
          <Grid item>
            <AsterChip
              label={wlData?.saleStatus?.name || '-'}
              style={{
                ...colorStatusesByCode(wlData?.saleStatus?.code)
              }}
            />
          </Grid>

          {wlData?.carfinStatus?.name && (
            <Grid item>
              <AsterChip
                label={`ФС: ${wlData?.carfinStatus?.name || '-'}`}
                style={{
                  ...{
                    color: 'rgb(65, 111, 198)',
                    backgroundColor: 'rgb(245, 246, 255)'
                  }
                }}
              />
            </Grid>
          )}
        </Grid>

        <Grid item xs={12} style={{ marginTop: 10 }}>
          <FormControlLabel
            label={'Подтвердить корректное ведение РЛ'}
            control={<Checkbox size="small" color={'primary'} />}
            value={!!wlData?.ropCheck}
            onChange={(_, newValue) => handleRopCheck(newValue)}
          />
        </Grid>

        <Grid item xs={12} style={{ margin: '20px 0 16px 0' }}>
          <Card>
            <CardContent className={classes.statusProgressContent}>
              <Grid container>
                <Grid item xs={12}>
                  <AsterTypography variant="body2">
                    {wlData?.contractStatusTrack?.name || ''}
                  </AsterTypography>
                </Grid>
                <Grid item container alignItems="center">
                  <Grid item style={{ minWidth: 270 }}>
                    <AsterProgress
                      variant="determinate"
                      value={progressPercent}
                    />
                  </Grid>
                  <Grid item style={{ marginLeft: 12 }}>
                    <AsterTypography>
                      {[
                        wlData?.contractStatusTrack?.current || 0,
                        wlData?.contractStatusTrack?.total || 0
                      ].join('/')}
                    </AsterTypography>
                  </Grid>
                </Grid>
              </Grid>
            </CardContent>
          </Card>
        </Grid>
      </Grid>

      <Accordion expanded={expanded} className={classes.accordion}>
        <AccordionSummary className={classes.accordionSummary}>
          <Grid container alignItems="center" justifyContent="space-between">
            <Grid item>
              <AsterTypography variant="h6">
                {clsx(wlData?.client?.firstName, wlData?.client?.lastName)}
              </AsterTypography>
            </Grid>
            <Grid item>
              <AsterButton
                className={classes.expandBtn}
                onClick={() => setExpanded(!expanded)}
              >
                <ArrowForwardIosRounded
                  className={classes.expandBtnIcon}
                  style={{ transform: `rotate(${expanded ? -90 : 90}deg)` }}
                />
              </AsterButton>
            </Grid>
          </Grid>
        </AccordionSummary>
        <AccordionDetails className={classes.accordionDetails}>
          <Grid item container>
            <Grid
              item
              container
              className={clsx(classes.infoCard, classes.clientInfo)}
              spacing={4}
            >
              <Grid item xs={12} md={6}>
                <FieldInfoNG label={'Клиент'} labelStyle={{ minWidth: 136 }}>
                  <AsterTypography>
                    {clsx(wlData?.client?.firstName, wlData?.client?.lastName)}
                  </AsterTypography>
                </FieldInfoNG>
              </Grid>
              <Grid item xs={12} md={6}>
                <FieldInfoNG label={'Филиал'} labelStyle={{ minWidth: 136 }}>
                  <AsterTypography>
                    {wlData?.branch?.name || '-'}
                  </AsterTypography>
                </FieldInfoNG>
              </Grid>
              <Grid item xs={12} md={6}>
                <FieldInfoNG label={'Телефон'} labelStyle={{ minWidth: 136 }}>
                  <PhoneView phone={wlData?.client?.phoneNumber || '-'} />
                </FieldInfoNG>
              </Grid>
              <Grid item xs={12} md={6}>
                <FieldInfoNG label={'Время РЛ'} labelStyle={{ minWidth: 136 }}>
                  <TimerDiffDate date={wlData?.createdDate} />
                </FieldInfoNG>
              </Grid>
              <Grid item xs={12} md={6}>
                <FieldInfoNG
                  label={'Онлайн кредит'}
                  rootStyle={{ display: 'flex', alignItems: 'center' }}
                  labelStyle={{ minWidth: 136 }}
                >
                  <AsterTypography>
                    <CreditApprovalModal phone={wlData?.client?.phoneNumber} />
                  </AsterTypography>
                </FieldInfoNG>
              </Grid>
              <Grid item xs={12} md={6}>
                <FieldInfoNG
                  label={'Менеджер'}
                  rootStyle={{ display: 'flex', alignItems: 'center' }}
                  labelStyle={{ minWidth: 136 }}
                >
                  <AsterTypography>
                    {wlData?.assignToFullName || '-'}
                  </AsterTypography>
                </FieldInfoNG>
              </Grid>
              <Grid item xs={12} md={6}>
                <FieldInfoNG
                  label={'Долг сделки'}
                  labelStyle={{ minWidth: 136 }}
                >
                  <AsterTypography
                    style={{
                      color: ERROR_COLORS[600]
                    }}
                  >
                    50 000 ₸
                  </AsterTypography>
                </FieldInfoNG>
              </Grid>
            </Grid>

            <Grid
              item
              container
              className={clsx(classes.infoCard, classes.carInfo)}
              onClick={() => {
                if (wlData?.car) {
                  handleCarClick(wlData?.car)
                }
              }}
            >
              {wlData?.car ? (
                <>
                  <Grid item xs={12} md={6} style={{ marginBottom: 10 }}>
                    <CardMedia
                      component="img"
                      alt={clsx(
                        wlData?.car?.marka,
                        wlData?.car?.model,
                        wlData?.car?.year
                      )}
                      height={144}
                      style={{ borderRadius: 8 }}
                      image={
                        wlData?.car?.photos ? wlData?.car?.photos?.[0] : CarImg
                      }
                      title={clsx(
                        wlData?.car?.marka,
                        wlData?.car?.model,
                        wlData?.car?.year
                      )}
                    />
                  </Grid>

                  <Grid item xs={12} md={6} className={classes.carInfoWrapper}>
                    <Grid item xs={12}>
                      <AsterTypography variant="h6" style={{ fontWeight: 600 }}>
                        {clsx(
                          wlData?.car?.marka,
                          wlData?.car?.model,
                          wlData?.car?.year
                        )}
                      </AsterTypography>
                    </Grid>
                    <Grid item xs={12}>
                      <AsterTypography>
                        {wlData?.car?.price?.toString()?.thousandSeparator() ||
                          0}{' '}
                        ₸
                      </AsterTypography>
                    </Grid>
                    <Grid item xs={12}>
                      <AsterTypography>
                        {wlData?.car?.vin || '-'}
                      </AsterTypography>
                    </Grid>
                    <Grid item xs={12}>
                      <AsterTypography>
                        {wlData?.car?.branch || '-'}
                      </AsterTypography>
                    </Grid>
                  </Grid>
                </>
              ) : (
                <NotFound title="Нет выбранного авто" />
              )}
            </Grid>
          </Grid>
        </AccordionDetails>
      </Accordion>

      <Grid item container style={{ marginTop: 16 }}>
        <WorkListTabs />
      </Grid>
      {activeCar?.vin && (
        <Modal fullScreen open={activeCar} onClose={() => handleCarClick(null)}>
          <CarData vin={activeCar.vin} onClose={() => handleCarClick(null)} />
        </Modal>
      )}
    </Grid>
  )
}
